import React from "react";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import SearchButton from "../SearchButton";
import ChatButton from "../ChatButton";
import NotificationButton from "../NotificationButton";

import { useStore } from "../../connect";

import styles from "./MainButtons.scss";

const cx = classnames.bind(styles);

const MainButtons = () => {
  const { search, profile, header, notifications, adaptive } = useStore();

  if (!profile.isLoggedIn) {
    return null;
  }

  if (adaptive.isLargeMobile || adaptive.isMobile) {
    return (
      <div className={cx("header-icons")}>
        {!search.searchVisible && <SearchButton hideTooltip />}
        <NotificationButton
          hideTooltip
          mobile
          notificationsNumber={notifications.notificationsNumber}
          notificationSubmenu
        />
      </div>
    );
  }

  return (
    header.sticky && (
      <div className={cx("header-icons")}>
        {!search.searchVisible && <SearchButton />}
        <ChatButton />
        <NotificationButton
          notificationsNumber={notifications.notificationsNumber}
          notificationSubmenu
        />
      </div>
    )
  );
};

export default observer(MainButtons);
